import { Menu, MenuItem } from "@mui/material";
import {
  arrowLeft,
  layersTwo,
  modalCloseIcon,
  plusIcon,
  threeDotsIcon,
} from "../../../utility-functions/assetLoader";
import classes from "./ChatDetail.module.css";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { JService } from "../../api-service/ApiService";
import { enqueueSnackbar } from "notistack";
import Button from "../../design/Button";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import EditContactModal from "../Modals/EditContactModal";
import BlockContactModal from "../Modals/BlockContactModal";
import UnblockContactModal from "../Modals/UnblockContactModal";
import { useDebounce } from "../../../utility-functions/useDebounce";
import Message from "../Components/Message";
import {
  formatDate,
  isSameLocalDate,
  isWithin24Hours,
  to24HourFormat,
} from "../../../utility-functions";
import { CustomSelect } from "../../design/components/customComponents";
import AnimationPage from "../../shared/animation-page/AnimationPage";
import {
  setMessages,
  prependMessages,
  addMessage,
} from "../../features/whatsapp-chat/whatsappChat";
import {
  clearUnread,
  updateLatestMessage,
} from "../../features/whatsapp-contacts/whatsappContacts";
import { format } from "date-fns";

const typeOptions = [
  { value: "Text", displayValue: "Text" },
  { value: "Variable", displayValue: "Variable" },
];

const templateVariableOptions = [
  { value: "Contact name", displayValue: "Contact name" },
  { value: "Contact phone number", displayValue: "Contact phone number" },
  { value: "Agent name", displayValue: "Agent name" },
  { value: "Agent virtual number", displayValue: "Agent virtual number" },
  { value: "Organization name", displayValue: "Organization name" },
];

const ChatDetail = ({ chatDetails, blockedList, getBlockedList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { canManageWhatsappMessageTemplates, canBlockCandidates } = useSelector(
    (state) => state?.auth?.permissions
  );
  const orgName = useSelector(
    (state) => state?.account?.value?.allOrgs[0]?.company
  );
  const agentName = useSelector(
    (state) =>
      state?.account?.value?.data?.first_name +
      " " +
      state?.account?.value?.data?.last_name
  );
  const phoneNumberId = useSelector(
    (state) =>
      state?.whatsappBusiness?.value?.phone_numbers?.[0]?.phone_number_id
  );
  const { phone_numbers } = useSelector(
    (state) => state?.whatsappBusiness?.value
  );
  const allMessages = useSelector(
    (state) => state?.whatsappChat?.byContact[chatDetails.id]
  );
  const phoneNumber =
    phone_numbers?.[0]?.country_code + phone_numbers?.[0]?.phone_number;

  //Refs
  const textareaRef = useRef(null);
  const containerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const templatesListRef = useRef(null);
  const prevCountRef = useRef(0);

  //States

  const [contactName, setContactName] = useState(chatDetails?.name || "");
  //Above state is because name can be updated via edit contact modal

  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [templates, setAllTemplates] = useState([]);
  const [templateVariables, setTemplateVariables] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showModal, setShowModal] = useState({
    edit: false,
    block: false,
    unblock: false,
  });
  const [isBlocked, setIsBlocked] = useState(false);
  const [templateSearchTerm, setTemplateSearchTerm] = useState("");
  const [nextChatUrl, setNextChatUrl] = useState(null);
  const [isChatLoadingMore, setIsChatLoadingMore] = useState(false);
  const [nextTemplatesUrl, setNextTemplatesUrl] = useState(null);
  const [isTemplatesLoadingMore, setIsTemplatesLoadingMore] = useState(false);
  const [windowNotInitiated, setWindowNotInitiated] = useState(false);
  const [notWithinReplyWindow, setNotWithinReplyWindow] = useState(false);
  const [textMessageValue, setTextMessageValue] = useState("");
  const [templateMessageValue, setTemplateMessageValue] = useState("");
  const [originalTemplateText, setOriginalTemplateText] = useState("");
  const [showTemplates, setShowTemplates] = useState(false);
  const [showMessagePreview, setShowMessagePreview] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTemplateCategory, setSelectedTemplateCategory] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [authMessageValue, setAuthMessageValue] = useState("");

  const [authMeta, setAuthMeta] = useState({
    addSecurityRecommendation: true,
    codeExpirationMinutes: 10,
  });

  const debouncedTemplateSearchTerm = useDebounce(templateSearchTerm, 500);
  const sendButtonIsDisabled =
    (selectedTemplateCategory === "AUTHENTICATION" &&
      (!otpValue.trim() || !authMessageValue.trim())) ||
    (templateVariables?.length &&
      templateVariables?.some((v) => v.value?.trim() === ""));

  //Handlers
  const threeDotsClickHandler = (e) => {
    e.stopPropagation();
    setIsDropdownVisible(true);
    setDropdownAnchorEl(e.currentTarget || null);
  };

  const threeDotsAutoClose = (e) => {
    const path = e.composedPath()?.map((pathItem) => {
      let newPathItem = null;
      newPathItem =
        pathItem?.tagName?.toLowerCase() +
        (pathItem?.className ? "." + pathItem?.className : "");
      return newPathItem;
    });

    if (!path?.length || path[0]?.includes("div.MuiBackdrop-root")) {
      setIsDropdownVisible(false);
      setDropdownAnchorEl(null);
      return;
    }
  };

  const listAllApprovedTemplates = async (url) => {
    try {
      setIsLoading(true);
      let baseUrl = `/api/v1/whatsapp/templates/?status=${JSON.stringify([
        "APPROVED",
      ])}&page=1`;

      if (debouncedTemplateSearchTerm.trim() !== "") {
        baseUrl += `&search=${debouncedTemplateSearchTerm}`;
      }

      const response = await JService.get(url || baseUrl);

      if (!response?.success)
        throw new Error(
          response?.message || "Could not retrieve templates list"
        );

      const { next, results } = response.data;

      if (!url) {
        setAllTemplates(results);
      } else {
        if (results?.length > 0) {
          setAllTemplates((prev) => [...prev, ...results]);
        }
      }
      setNextTemplatesUrl(next);
    } catch (error) {
      enqueueSnackbar(error?.message || "Could not retrieve templates list", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const showTemplatesHandler = () => {
    setShowDrawer(true);
  };

  const dropdownClickHandler = (e) => {
    const menuItemType = e.target.dataset.menuitemtype;
    if (menuItemType === "edit") {
      setShowModal((prev) => ({ ...prev, edit: true }));
    } else if (menuItemType === "block") {
      setShowModal((prev) => ({ ...prev, block: true }));
    } else if (menuItemType === "unblock") {
      setShowModal((prev) => ({ ...prev, unblock: true }));
    }
    setIsDropdownVisible(false);
    setDropdownAnchorEl(null);
  };

  //Common function for block and unblock modal
  async function blockUnblockSaveHandler() {
    try {
      const url = "/api/v1/auth/blocked-list/";
      const cc = chatDetails?.country_code,
        number = chatDetails?.number;
      let fallbackSnackFailureMessage = "",
        fallbackSnackSuccessMessage = "",
        response;

      if (isBlocked) {
        const query = new URLSearchParams({ cc, number });
        fallbackSnackFailureMessage = "Failed to unblock contact";
        fallbackSnackSuccessMessage = "Successfully unblocked contact";
        response = await JService.delete(url + "?" + query);
      } else if (!isBlocked) {
        const candidateName = contactName;
        if (!candidateName) throw new Error("Contact name missing");

        const payload = {
          number: number,
          country_code: cc,
          name: candidateName,
        };
        fallbackSnackFailureMessage = "Failed to block contact";
        fallbackSnackSuccessMessage = "Successfully blocked contact";
        response = await JService.post(url, payload);
      } else
        throw new Error(
          `Unknown value for 'is_blocked' (${isBlocked}) for contact. Contact FreJun support.`
        );

      if (!response?.success)
        throw new Error(response?.message || fallbackSnackFailureMessage);
      enqueueSnackbar(response?.message || fallbackSnackSuccessMessage, {
        variant: "success",
      });
      getBlockedList();
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: "error" });
    } finally {
      setShowModal((prev) => ({ ...prev, block: false, unblock: false }));
    }
  }

  const getAllMessages = async (url) => {
    try {
      if (!url) setIsLoading(true);
      const baseUrl =
        `/api/v1/whatsapp/send-whatsapp-message?contact_id=${chatDetails?.id}&page=1` +
        `&phone_number_id=${phoneNumberId}`;
      const response = await JService.get(url || baseUrl);

      if (!response?.success)
        throw new Error(response?.message || "Unable to fetch messages");

      const { next, results } = response.data;
      const fetched = [...results].reverse();

      if (!url) {
        // Initial load
        dispatch(
          setMessages({
            contactId: chatDetails.id,
            messages: fetched,
          })
        );
        dispatch(clearUnread(chatDetails.id));
        await markMessagesAsRead();
        prevCountRef.current = fetched.length;
      } else {
        // Loading older messages
        if (fetched.length > 0) {
          const container = containerRef.current;
          const prevHeight = container.scrollHeight;
          dispatch(
            prependMessages({
              contactId: chatDetails.id,
              messages: fetched,
            })
          );
          setTimeout(() => {
            const newHeight = container.scrollHeight;
            container.scrollTop = newHeight - prevHeight;
          }, 0);
        }
      }

      setNextChatUrl(next);
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const sendMessageHandler = async (type = "text") => {
    let payload;
    if (type === "text") {
      payload = {
        phone_number: chatDetails?.country_code + chatDetails?.number,
        type: type,
        message: textMessageValue,
        sender_number: phoneNumber,
      };
    } else if (type === "template") {
      const isAuth = selectedTemplateCategory === "AUTHENTICATION";

      const parameters = templateVariables?.map((t) => {
        let value = t?.value;
        if (t.type === "Variable") {
          if (value === "Contact name") value = contactName;
          else if (value === "Contact phone number")
            value = chatDetails?.country_code + chatDetails?.number;
          else if (value === "Agent name") value = agentName;
          else if (value === "Agent virtual number") value = phoneNumber;
          else if (value === "Organization name") value = orgName;
        }
        return { type: "text", text: value };
      });

      payload = {
        phone_number: chatDetails?.country_code + chatDetails?.number,
        type: type,
        message: isAuth ? authMessageValue : templateMessageValue,
        sender_number: phoneNumber,
        template: {
          name: templateName,
          language: {
            code: "en_US",
          },
          components: isAuth ?
            [
              {
                type: "body",
                parameters: [{ type: "text", text: otpValue }],
              },
              {
                type: "button",
                sub_type: "url",
                index: "0",
                parameters: [{ type: "text", text: otpValue }],
              },
            ]
            : [
              {
                type: "body",
                parameters: parameters || [],
              },
            ],
        },
      };
    }
    try {
      setIsLoading(true);
      const response = await JService.post(
        "/api/v1/whatsapp/send-whatsapp-message/",
        payload
      );
      if (!response?.success)
        throw new Error(
          response?.message || "Error occured while sending message"
        );
      enqueueSnackbar(response?.message || "Message sent successfully", {
        variant: "success",
      });
      dispatch(
        addMessage({
          contactId: response?.data?.contact,
          message: {
            ...response?.data,
          },
        })
      );

      dispatch(
        updateLatestMessage({
          contactId: Number(chatDetails?.id),
          latestMessage: {
            message: payload.message,
            datetime: format(
              new Date(response?.data?.created_at),
              "dd-MM-yyyy hh:mm:ss a"
            ),
          },
        })
      );
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: "error" });
    } finally {
      setIsLoading(false);
      setShowMessagePreview(false);
      setShowDrawer(false);
      setShowTemplates(false);
      setTextMessageValue("");
      setTemplateSearchTerm("");
    }
  };

  const drawerCloseHandler = () => {
    setShowDrawer(false);
    setShowTemplates(false);
    setTemplateMessageValue("");
  };

  const selectTemplateHandler = (t) => {
    const bodyComp = t?.components?.find(
      (c) => c?.type?.toUpperCase() === "BODY"
    );
    const footerComp = t?.components?.find(
      (c) => c?.type?.toUpperCase() === "FOOTER"
    );

    setAuthMeta({
      addSecurityRecommendation:
        bodyComp?.add_security_recommendation ?? true,
      codeExpirationMinutes: footerComp?.code_expiration_minutes ?? 10,
    });
    setShowMessagePreview(true);
    const text = t?.components?.[0]?.text;
    setOriginalTemplateText(text);
    setTemplateMessageValue(text);
    setTemplateName(t?.name);
    const exampleValues = t?.components?.[0]?.example?.body_text?.[0] || [];
    setTemplateVariables(
      exampleValues.map((_, idx) => ({
        id: idx + 1,
        type: "Text",
        value: "",
      }))
    );
    setSelectedTemplateCategory(t?.category?.toUpperCase());
    setOtpValue("");
    setAuthMessageValue("");
  };

  const selectTypeHandler = (e, id) => {
    setTemplateVariables((prev) => {
      const temp = [...prev];
      let obj = temp.find((variable) => variable.id === id);
      obj.type = e.target.value;
      obj.value = "";
      return temp;
    });
  };

  const valueChangeHandler = (e, id) => {
    setTemplateVariables((prev) => {
      const temp = [...prev];
      let obj = temp.find((variable) => variable.id === id);
      obj.value = e.target.value;
      return temp;
    });
  };

  const loadPreviousMessages = () => {
    if (isChatLoadingMore || !nextChatUrl) return;
    setIsChatLoadingMore(true);
    getAllMessages(nextChatUrl).finally(() => setIsChatLoadingMore(false));
  };

  const scrollChatHandler = () => {
    if (containerRef.current.scrollTop === 0) {
      loadPreviousMessages();
    }
  };

  const loadNextTemplates = () => {
    if (isTemplatesLoadingMore || !nextTemplatesUrl) return;
    setIsTemplatesLoadingMore(true);
    listAllApprovedTemplates(nextTemplatesUrl).finally(() =>
      setIsTemplatesLoadingMore(false)
    );
  };

  const scrollTemplateHandler = () => {
    const el = templatesListRef.current;
    if (!el) return;

    const { scrollTop, clientHeight, scrollHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight) {
      loadNextTemplates();
    }
  };

  const saveContactHandler = async (newName, _) => {
    try {
      const url = "/api/v1/whatsapp/manage-contact/",
        payload = {
          contact_id: chatDetails?.id,
          name: newName,
        };
      const response = await JService.patch(url, payload);
      if (!response.success)
        throw new Error(
          response?.message || "Failed to update contact details"
        );

      enqueueSnackbar(response?.message || "Contact updated successfully", {
        variant: "success",
      });
      setContactName(response?.data?.name);
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: "error" });
    } finally {
      setShowModal((prev) => ({ ...prev, edit: false }));
    }
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (textMessageValue.trim()) sendMessageHandler("text");
    }
  };

  const markMessagesAsRead = async () => {
    try {
      const response = await JService.patch(
        `/api/v1/whatsapp/send-whatsapp-message/`,
        {
          contact_id: chatDetails?.id,
          phone_number_id: phoneNumberId,
        }
      );
      if (!response?.success)
        throw new Error(response?.message || "Cannot mark messages as read");
      dispatch(clearUnread(chatDetails?.id));
    } catch (error) {
      enqueueSnackbar(error?.message, { variant: "error" });
    }
  };

  //Effects

  useEffect(() => {
    const prevCount = prevCountRef.current;
    const currCount = allMessages?.length;
    if (currCount > prevCount) {
      markMessagesAsRead();
    }
    prevCountRef.current = currCount;
  }, [allMessages]);

  useEffect(() => {
    if (isLoading) return;
    if (allMessages?.length > 0) {
      let lastReceived = null;
      for (let i = allMessages?.length - 1; i >= 0; i--) {
        if (allMessages?.[i]?.status === "RECEIVED") {
          lastReceived = allMessages?.[i];
          break;
        }
      }
      if (!lastReceived) {
        setWindowNotInitiated(true);
        setNotWithinReplyWindow(false);
      } else {
        setWindowNotInitiated(
          !isWithin24Hours(lastReceived?.created_at) &&
          lastReceived?.id !== allMessages?.[allMessages?.length - 1]?.id
        );
        setNotWithinReplyWindow(!isWithin24Hours(lastReceived?.created_at));
      }
    } else {
      if (windowNotInitiated) setWindowNotInitiated(false);
      if (notWithinReplyWindow) setNotWithinReplyWindow(false);
    }
  }, [allMessages, isLoading]);

  useEffect(() => {
    if (!chatDetails?.id || !showDrawer) return;
    listAllApprovedTemplates();
  }, [debouncedTemplateSearchTerm, chatDetails?.id, showDrawer]);

  useEffect(() => {
    if (chatDetails?.id && phoneNumberId) {
      getAllMessages();
    }
  }, [chatDetails?.id, phoneNumberId]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", scrollChatHandler);
      return () => container.removeEventListener("scroll", scrollChatHandler);
    }
  }, [nextChatUrl, isChatLoadingMore]);

  useEffect(() => {
    if (!showDrawer) return;
    const container = templatesListRef.current;
    if (!container) return;

    container.addEventListener("scroll", scrollTemplateHandler);
    return () => container.removeEventListener("scroll", scrollTemplateHandler);
  }, [showDrawer, nextTemplatesUrl, isTemplatesLoadingMore]);

  useEffect(() => {
    if (isDropdownVisible) window.addEventListener("click", threeDotsAutoClose);
    else window.removeEventListener("click", threeDotsAutoClose);

    return () => {
      window.removeEventListener("click", threeDotsAutoClose);
    };
  }, [isDropdownVisible]);

  useEffect(() => {
    setIsBlocked(
      blockedList?.some(
        ({ number, country_code: cc }) =>
          `${cc}${number}` === chatDetails?.country_code + chatDetails?.number
      ) || false
    );
  }, [blockedList, chatDetails?.country_code, chatDetails?.number]);

  useEffect(() => {
    if (!originalTemplateText) return;

    let newMsg = originalTemplateText;
    templateVariables?.forEach(({ id, value, type }) => {
      let val = value;
      if (type === "Variable") {
        if (val === "Contact name") val = contactName;
        else if (val === "Contact phone number")
          val = chatDetails?.country_code + chatDetails?.number;
        else if (val === "Agent name") val = agentName;
        else if (val === "Agent virtual number") val = phoneNumber;
        else if (val === "Organization name") val = orgName;
      }
      const replacement = val || `{{${id}}}`;
      const re = new RegExp(`\\{\\{${id}\\}\\}`, "g");
      newMsg = newMsg.replace(re, replacement);
    });

    setTemplateMessageValue(newMsg);
  }, [templateVariables, originalTemplateText]);

  useEffect(() => {
    const t = textareaRef.current;
    if (!t) return;
    t.style.height = "auto";
    t.style.height = t.scrollHeight + "px";
  }, [textMessageValue]);

  useEffect(() => {
    setContactName(chatDetails?.name || "");
  }, [chatDetails?.name]);

  useLayoutEffect(() => {
    if (!isLoading && allMessages?.length) {
      messagesEndRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [allMessages, isLoading]);

  useEffect(() => {
    if (selectedTemplateCategory !== "AUTHENTICATION") return;

    const otp = otpValue.trim();
    if (!otp) {
      setAuthMessageValue("");
      return;
    }

    const securityText = authMeta.addSecurityRecommendation
      ? " For your security, do not share this code." : "";

    const expiryMinutes = Number(authMeta.codeExpirationMinutes);
    const expiryText = expiryMinutes
      ? ` This code expires in ${expiryMinutes} minute${expiryMinutes === 1 ? "" : "s"}.`
      : "";

    setAuthMessageValue(
      `${otp} is your verification code.${securityText}${expiryText}`
    );
  }, [selectedTemplateCategory, otpValue, authMeta]);

  return (
    <div className={classes.container}>
      {Object.keys(chatDetails)?.length > 0 ? (
        <>
          <div className={classes.header}>
            <div className={classes.avatar}>
              <span>{contactName?.[0]}</span>
            </div>
            <div className={classes.name}>
              <h6>{contactName}</h6>
              <div
                className={classes.threeDotsContainer}
                onClick={(e) => threeDotsClickHandler(e)}
              >
                {threeDotsIcon()}
              </div>
              <Menu
                sx={{
                  "& .MuiList-root": { width: "175px" },
                  "& .MuiPaper-root": { border: "1px solid var(--grey-200)" },
                }}
                open={isDropdownVisible}
                anchorEl={dropdownAnchorEl}
              >
                <MenuItem
                  onClick={dropdownClickHandler}
                  data-menuitemtype="edit"
                  sx={{ cursor: "pointer" }}
                >
                  &nbsp;&nbsp;Edit
                </MenuItem>

                {canBlockCandidates && (
                  <MenuItem
                    onClick={dropdownClickHandler}
                    data-menuitemtype={isBlocked ? "unblock" : "block"}
                    sx={{ cursor: "pointer" }}
                  >
                    &nbsp;&nbsp;{isBlocked ? "Unblock" : "Block"}
                  </MenuItem>
                )}
              </Menu>
              {showModal.edit ? (
                <EditContactModal
                  visible={showModal.edit}
                  closeModalHandler={() =>
                    setShowModal((prev) => ({ ...prev, edit: false }))
                  }
                  name={contactName || ""}
                  phoneNumber={
                    chatDetails?.country_code + chatDetails?.number || ""
                  }
                  saveContactHandler={saveContactHandler}
                />
              ) : null}
              {showModal.block ? (
                <BlockContactModal
                  visible={showModal.block}
                  closeModalHandler={() =>
                    setShowModal((prev) => ({ ...prev, block: false }))
                  }
                  name={contactName || ""}
                  saveHandler={blockUnblockSaveHandler}
                />
              ) : null}
              {showModal.unblock ? (
                <UnblockContactModal
                  visible={showModal.unblock}
                  closeModalHandler={() =>
                    setShowModal((prev) => ({ ...prev, unblock: false }))
                  }
                  name={contactName || ""}
                  saveHandler={blockUnblockSaveHandler}
                />
              ) : null}
            </div>
          </div>
          <div ref={containerRef} className={classes.messagesContainer}>
            {isLoading && allMessages?.length === 0 ? (
              <AnimationPage
                variant={"transparent"}
                style={{ transform: "none" }}
              />
            ) : allMessages?.length > 0 ? (
              allMessages?.map((msg, idx, arr) => {
                let showName = true,
                  showDate = false;
                const isReceived = msg?.status === "RECEIVED";

                if (idx !== 0) {
                  if (
                    !isSameLocalDate(arr[idx - 1]?.created_at, msg?.created_at)
                  ) {
                    showDate = true;
                  }
                  if (arr[idx - 1]?.owner?.id === msg?.owner?.id)
                    showName = false;
                  else if (arr[idx - 1]?.status === "RECEIVED" && isReceived)
                    showName = false;
                } else {
                  showDate = true;
                }
                return (
                  <div key={msg?.id}>
                    {showDate && (
                      <div className={classes.messageChunkDate}>
                        <div>
                          <span>{formatDate(msg?.created_at)}</span>
                        </div>
                      </div>
                    )}
                    {showName && (
                      <div
                        style={{
                          flexDirection: isReceived ? "row-reverse" : "row",
                        }}
                        className={classes.senderNameContainer}
                      >
                        <span>
                          {isReceived ? contactName : msg?.owner?.name}
                        </span>
                        <div
                          style={{
                            background: isReceived ? "#FAFAFA" : "#FCF5FE",
                            border: isReceived
                              ? "1px solid #E4E4E7"
                              : "1px solid #F8E9FE",
                          }}
                        >
                          <span
                            style={{
                              color: isReceived ? "#70707B" : "#9C27B0",
                            }}
                          >
                            {isReceived
                              ? contactName?.[0]
                              : msg?.owner?.name?.[0]}
                          </span>
                        </div>
                      </div>
                    )}
                    <Message
                      key={msg?.id}
                      message={msg?.message}
                      time={to24HourFormat(msg?.created_at)}
                      status={msg?.status}
                    />
                  </div>
                );
              })
            ) : (
              <div className={classes.messageChunkDate}>
                <div>
                  <span>{formatDate(Date.now())}</span>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>
          {isBlocked ? (
            <div className={classes.blockedWarning}>
              <p>Can't send message to blocked contact</p>
            </div>
          ) : allMessages?.length === 0 ||
            notWithinReplyWindow ||
            windowNotInitiated ||
            showTemplates ? (
            //Only templates can be sent to initiate a conversation and when reply window is closed.
            //(show templates state is set when user clicks on + icon to send a template when they're within reply window)
            <>
              <div className={classes.sendTemplateContainer}>
                {showMessagePreview ? (
                  <Button
                    hierarchy="green"
                    variant="outlined"
                    buttonText="Send"
                    disabled={sendButtonIsDisabled}
                    buttonStyle={{ ...sendButtonStyles, float: "right" }}
                    onClick={() => sendMessageHandler("template")}
                    isLoading={isLoading}
                  />
                ) : (
                  <input
                    type="text"
                    placeholder="Search template message"
                    onClick={showTemplatesHandler}
                    onChange={(e) => setTemplateSearchTerm(e.target.value)}
                  />
                )}
              </div>
              {showDrawer ? (
                <div
                  style={{
                    bottom:
                      templates?.length > 0 || templateSearchTerm
                        ? "79px"
                        : "1px",
                    borderRadius:
                      templates?.length > 0 || templateSearchTerm
                        ? "12px 12px 0 0"
                        : "12px 12px 8px 0",
                  }}
                  className={classes.templateDrawer}
                >
                  <div className={classes.tempateDrawerHeader}>
                    {showMessagePreview ? (
                      <>
                        <button
                          onClick={() => {
                            setShowMessagePreview(false); //For returning back to template selection
                          }}
                          style={{ float: "left", margin: "0 0 0 20px" }}
                        >
                          {arrowLeft()}
                        </button>
                        <span>Message preview</span>
                      </>
                    ) : (
                      <>
                        <span>Templates</span>
                        <button onClick={drawerCloseHandler}>
                          {modalCloseIcon()}
                        </button>
                      </>
                    )}
                  </div>

                  {showMessagePreview ? (
                    <div className={classes.msgPreview}>
                      <div className={classes.previewContainer}>
                        <div>
                          <p>{selectedTemplateCategory === "AUTHENTICATION" ? authMessageValue : templateMessageValue}</p>
                        </div>
                      </div>
                      {selectedTemplateCategory === "AUTHENTICATION" && (
                        <div className={classes.authPreviewFields}>
                          <input
                            type="text"
                            placeholder="Enter OTP"
                            value={otpValue}
                            onChange={(e) => setOtpValue(e.target.value)}
                          />
                        </div>
                      )}
                      {selectedTemplateCategory !== "AUTHENTICATION" && (
                        <div className={classes.valuesSection}>
                          {templateVariables?.length > 0 ? (
                            <>
                              <h6>Select values</h6>
                              {templateVariables.map((v) => (
                                <div className={classes.variableContainer}>
                                  <span>{`{{${v.id}}}`}</span>
                                  <CustomSelect
                                    defaultValue="Type"
                                    value={v?.type}
                                    options={typeOptions}
                                    selectStyles={{
                                      borderRadius: "6px",
                                      width: "120px",
                                    }}
                                    handleChange={(e) =>
                                      selectTypeHandler(e, v.id)
                                    }
                                  />
                                  {v?.type === "Text" ? (
                                    <input
                                      type="text"
                                      placeholder="Enter text"
                                      value={v.value}
                                      onChange={(e) =>
                                        valueChangeHandler(e, v.id)
                                      }
                                    />
                                  ) : (
                                    <CustomSelect
                                      defaultValue={"Select variable"}
                                      options={templateVariableOptions}
                                      defaultValStyles={{ color: "#A0A0AB" }}
                                      selectStyles={{ borderRadius: "6px" }}
                                      value={v?.value}
                                      handleChange={(e) =>
                                        valueChangeHandler(e, v.id)
                                      }
                                    />
                                  )}
                                </div>
                              ))}
                            </>
                          ) : (
                            <div className={classes.noVariables}>
                              <p>
                                The selected template does not have any variables.
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : isLoading ? (
                    <AnimationPage
                      style={{ marginBottom: "20px", transform: "none" }}
                    />
                  ) : templates?.length > 0 ? (
                    <div
                      ref={templatesListRef}
                      className={classes.templatesList}
                    >
                      {templates?.map((t) => (
                        <p onClick={() => selectTemplateHandler(t)} key={t?.id}>
                          {t?.name}
                        </p>
                      ))}
                    </div>
                  ) : templateSearchTerm ? (
                    <div className={classes.noTemplateFound}>
                      <span>No template found</span>
                    </div>
                  ) : (
                    <div className={classes.templateDrawerBody}>
                      <div>{layersTwo("#3F3F46", 32, 32)}</div>
                      <h6>No message templates </h6>
                      <p
                        style={{
                          marginBottom: !canManageWhatsappMessageTemplates
                            ? "86px"
                            : 0,
                        }}
                      >
                        {canManageWhatsappMessageTemplates
                          ? "Add templates to start messaging."
                          : "Please contact your account admin to add templates to start messaging."}
                      </p>
                      {canManageWhatsappMessageTemplates && (
                        <Button
                          buttonText="Create template"
                          hierarchy="green"
                          variant="contained"
                          buttonStyle={{
                            margin: "32px 0 60px 0",
                            fontSize: "14px",
                            lineHeight: "20px",
                            padding: "10px 16px",
                          }}
                          onClick={() => navigate("/w-template/create")}
                        />
                      )}
                    </div>
                  )}
                </div>
              ) : null}

              {windowNotInitiated ? (
                <div className={classes.replyWindowClosed}>
                  <span>
                    Custom messages available after customer responds.
                  </span>
                </div>
              ) : notWithinReplyWindow ? (
                <div className={classes.replyWindowClosed}>
                  <span>
                    Session expired. Send template message to restart
                    conversation.
                  </span>
                </div>
              ) : null}
            </>
          ) : (
            <div className={classes.sendMsgContainer}>
              <div>
                <textarea
                  value={textMessageValue}
                  onChange={(e) => setTextMessageValue(e.target.value)}
                  placeholder="Enter message"
                  rows={1}
                  ref={textareaRef}
                  onKeyDown={keyDownHandler}
                />
                <button
                  onClick={() => {
                    setShowTemplates(true);
                    setShowDrawer(true);
                  }}
                >
                  {plusIcon("#70707B")}
                </button>
              </div>
              <Button
                hierarchy="green"
                variant="outlined"
                buttonText="Send"
                disabled={textMessageValue?.trim() === ""}
                buttonStyle={sendButtonStyles}
                onClick={() => sendMessageHandler("text")}
                isLoading={isLoading}
              />
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default ChatDetail;

const sendButtonStyles = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
  width: "63px",
  borderRadius: "6px",
};
